import { get, post } from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { showToast } from "utils"
import {
  getEmailSetupFailed,
  getEmailSetupSuccess,
  getVisitorListFailed,
  getVisitorListSuccess,
  updateEmailSetupFailed,
  updateEmailSetupSuccess,
} from "./actions"
import * as url from "helpers/url_helper"
import {
  GET_EMAIL_SETUP,
  GET_VISITOR_LIST,
  UPDATE_EMAIL_SETUP,
} from "./actionTypes"

function* getVisitorList({ payload: params }) {
  try {
    const response = yield get(url.ADMIN_VISITOR_URL, { params })
    yield put(getVisitorListSuccess(response))
  } catch (error) {
    yield put(getVisitorListFailed(error))
    showToast("error", error, "Error")
  }
}

function* getEmailSetup({ payload: params }) {
  try {
    const response = yield get(url.EMAIL_SETUP_URL)
    yield put(getEmailSetupSuccess(response))
  } catch (error) {
    yield put(getEmailSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateEmailSetup({ payload: params }) {
  try {
    const response = yield post(url.EMAIL_SETUP_URL, params)
    yield put(updateEmailSetupSuccess(response))
    showToast("success", "Updated successfully", "Success")
  } catch (error) {
    yield put(updateEmailSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* visitorsSaga() {
  yield takeEvery(GET_VISITOR_LIST, getVisitorList)
  yield takeEvery(GET_EMAIL_SETUP, getEmailSetup)
  yield takeEvery(UPDATE_EMAIL_SETUP, updateEmailSetup)
}

export default visitorsSaga
